import axios, { CancelToken } from 'axios';

import { ClientDataRequest } from 'models/ClientDataRequest';
import { PreviewDataRequest } from 'models/PreviewDataRequest';
import { PreviewDataResponse } from 'models/PreviewDataResponse';
import { PreviewConfig } from 'types';
import { ClientDataResponse } from '../models/ClientDataResponse';
import AxiosHelper from 'services/AxiosHelper';
import { PageLayoutRequest } from 'models/PageLayoutRequest';
import { AutocompleteRequest, AutocompleteResponse } from 'models/AutocompleteResponse';
import { CompareItemRequest } from 'models/CompareItemRequest';
import { CompareDataResponse } from 'models/CompareDataResponse';

class PreviewClient {
	private baseUrl: string;
	private previewClientDataUrl: string;
	private initialDataUrl: string;
	private getPageLayoutUrl: string;
	private autocompleteUrl: string;
	private compareItemsURL: string;
	private addToCartURL: string;
	private compareItemURL: string;
	constructor(config: PreviewConfig) {
		this.baseUrl = config.apiUrl || 'https://searchapi-dev.americaneagle.com';
		this.previewClientDataUrl = '/api/internal-preview/get-client-data';
		this.initialDataUrl = '/api/internal-preview/get-preview-data';
		this.getPageLayoutUrl = '/api/internal-preview/page-layout';
		this.autocompleteUrl = '/api/autocomplete';
		this.compareItemsURL = config.compareItemsURL || '/api/compare';
		this.compareItemURL = config.compareItemURL;
		this.addToCartURL = config.addToCartURL;
	}

	public async getClientData(
		request: ClientDataRequest,
		cancellationToken?: CancelToken
	): Promise<ClientDataResponse> {
		const result = await AxiosHelper.post<ClientDataResponse>(
			new URL(this.previewClientDataUrl, this.baseUrl).href,
			request,
			{
				cancelToken: cancellationToken,
			}
		);
		return result.data;
	}

	public async getPageLayout(request: PageLayoutRequest, cancellationToken?: CancelToken): Promise<any> {
		const result = await AxiosHelper.post<any>(new URL(this.getPageLayoutUrl, this.baseUrl).href, request, {
			cancelToken: cancellationToken,
		});

		return result.data;
	}

	public async getInitialData(
		request: PreviewDataRequest,
		cancellationToken?: CancelToken
	): Promise<PreviewDataResponse> {
		const result = await AxiosHelper.post<PreviewDataResponse>(
			new URL(this.initialDataUrl, this.baseUrl).href,
			request,
			{
				cancelToken: cancellationToken,
			}
		);

		return result.data;
	}

	public async getComparedItems(
		request: CompareItemRequest,
		cancellationToken?: CancelToken
	): Promise<CompareDataResponse> {
		const result = await AxiosHelper.post<CompareDataResponse>(
			new URL(this.compareItemsURL, this.baseUrl).href,
			request,
			{
				cancelToken: cancellationToken,
			}
		);

		return result.data;
	}

	public async autocomplete(
		request: AutocompleteRequest,
		cancellationToken?: CancelToken
	): Promise<AutocompleteResponse> {
		const result = await axios.post<AutocompleteResponse>(
			new URL(this.autocompleteUrl, this.baseUrl).href,
			request,
			{
				cancelToken: cancellationToken,
			}
		);

		return result.data;
	}

	public async addToCart(bodyFormData) {
		return axios({
			method: 'post',
			url: this.addToCartURL,
			data: bodyFormData,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				// Cookie: document.cookie,
			},
		});
	}

	public async addComparision(productId, categoryId) {
		return axios({
			method: 'get',
			url: `${this.compareItemURL}?productId=${productId}&categoryId=${categoryId}&_=1611753293510`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				// Cookie: document.cookie,
			},
		});
	}
}

export default PreviewClient;
